import http from 'Services/HttpService';

import { baseUrl } from 'Utils/envLoader';

const DocumentationService = {
    getDocumentationById: (id) => {
        return http.get(`${baseUrl}/cliami/documentations/${id}`);
    },

    getDocumentations: () => {
        return http.get(`${baseUrl}/cliami/documentations`);
    },

    getDocumentationsByAppId: (appId) => {
        return http.get(`${baseUrl}/cliami/documentations/appId/${appId}`);
    },

    saveDocumentation: (documentation, documentationId) => {
        if (!documentationId) {
            return http.post(`${baseUrl}/cliami/documentations/create`, documentation);
        } else {
            return http.put(`${baseUrl}/cliami/documentations/update/${documentationId}`, documentation);
        }
    },

    deleteDocumentation: (documentationId) => {
        return http.delete(`${baseUrl}/cliami/documentations/${documentationId}`);
    },
};

export default DocumentationService;
